// LocationForm.js
import React, { useRef, useState } from "react";
import { FormField } from "./FormField";
import { Button } from "./button"; // adjust the import path as needed
import { storage } from "../firebase"; // adjust the path as needed
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import BilingualDescriptionField from "./BilingualDescriptionField";

export const LocationForm = ({ location, onChange, venueId }) => {
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      // Construct a unique storage path using locationId and a timestamp.
      const imagePath = `/venues/${venueId}/mapImage-${Date.now()}.jpg`;
      const storageRef = ref(storage, imagePath);

      // Upload the file
      await uploadBytes(storageRef, file);

      // Retrieve the download URL for the uploaded image
      const downloadUrl = await getDownloadURL(storageRef);

      // Update the mapImage field in the parent component
      onChange("mapImage", downloadUrl);
    } catch (error) {
      console.error("Error uploading image: ", error);
    } finally {
      setUploading(false);
    }
  };

  const handleUploadButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <fieldset className="p-4 border rounded mb-4">
      <legend className="font-semibold mb-2">Location</legend>

      <FormField
        label="Location Name"
        name="name"
        value={location?.name || ""}
        onChange={(e) => onChange("name", e.target.value)}
      />

      {/* ES escribe location.description (campo canónico); EN escribe
          location.descriptionEn — el sitio público hace fallback al español. */}
      <div className="mb-4">
        <BilingualDescriptionField
          label="Location Description"
          valueEs={location?.description || ""}
          valueEn={location?.descriptionEn || ""}
          onChangeEs={(v) => onChange("description", v)}
          onChangeEn={(v) => onChange("descriptionEn", v)}
          nameEs="locationDescription"
          nameEn="locationDescriptionEn"
          placeholderEs="Descripción de la ubicación (español)"
          placeholderEn="Location description (English) — se usa en la versión /en del sitio; si se deja vacía, se muestra la descripción en español"
          rows={4}
        />
      </div>

      <FormField
        label="Location Map URL"
        type="textarea"
        name="mapUrl"
        value={location?.mapUrl || ""}
        onChange={(e) => onChange("mapUrl", e.target.value)}
      />

      {/* Map Image Field with Preview and Upload */}
      <div className="mb-4">
        <label className="block font-medium mb-1">Map Image</label>
        {location?.mapImage ? (
          <img
            src={location.mapImage}
            alt="Map Preview"
            className="w-48 h-48 object-cover rounded mb-2"
          />
        ) : (
          <div className="w-48 h-48 bg-gray-100 flex items-center justify-center mb-2 rounded">
            <span className="text-gray-500">No Image</span>
          </div>
        )}

        <Button
          type="button"
          onClick={handleUploadButtonClick}
          disabled={uploading}
          // you can adjust the color as desired
          className="mt-2"
        >
          {uploading
            ? "Uploading..."
            : location?.mapImage
            ? "Change Image"
            : "Upload Image"}
        </Button>

        {/* Hidden file input */}
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
      </div>
    </fieldset>
  );
};
